var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaultData = function SvgFaultData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48.96 45.84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__fault-data-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.96px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__fault-data-1",
    d: "M5.35 44.86h38.26a4.36 4.36 0 003.9-6.31L28.38 3.39a4.36 4.36 0 00-7.81 0L1.45 38.55a4.36 4.36 0 003.9 6.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__fault-data-1",
    d: "M24.48 31.77a2.18 2.18 0 01-2.18-2.19V12.12a2.18 2.18 0 012.18-2.18 2.19 2.19 0 012.18 2.18v17.46a2.19 2.19 0 01-2.18 2.19zM24.48 40.5a2.18 2.18 0 01-2.18-2.18 2.18 2.18 0 012.18-2.19 2.19 2.19 0 012.18 2.19 2.19 2.19 0 01-2.18 2.18z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaultData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fault-data.b44d79b7.svg";
export { ForwardRef as ReactComponent };